module.exports = __webpack_public_path__ + "static/img/6.185a78cd.jpg";